export default __webpack_public_path__ + "a91b001f087bd8f8cba609329e8b5f35.png";